var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4847 15.3457C8.61707 15.3457 5.31421 15.9305 5.31421 18.2724C5.31421 20.6143 8.59611 21.22 12.4847 21.22C16.3523 21.22 19.6542 20.6343 19.6542 18.2933C19.6542 15.9524 16.3733 15.3457 12.4847 15.3457Z",
    stroke: "#738DA6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4846 12.0059C15.0227 12.0059 17.0799 9.94779 17.0799 7.40969C17.0799 4.8716 15.0227 2.81445 12.4846 2.81445C9.94655 2.81445 7.88845 4.8716 7.88845 7.40969C7.87988 9.93922 9.92369 11.9973 12.4523 12.0059H12.4846Z",
    stroke: "#738DA6",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profile-icon.0ac018d1923d38e807f07517cd19f8f7.svg";
export { ForwardRef as ReactComponent };